import { theme } from '../theme.js';
import { Icon } from './Icon.js';

interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  icon?: string;
  fullWidth?: boolean;
  disabled?: boolean;
  loading?: boolean;
  onClick?: () => void;
  type?: 'button' | 'submit';
}

export function Button({
  children, variant = 'primary', size = 'md', icon,
  fullWidth, disabled, loading, onClick, type = 'button',
}: ButtonProps) {
  const h = size === 'sm' ? 32 : size === 'lg' ? 52 : 44;
  const fs = size === 'sm' ? 13 : size === 'lg' ? 16 : 14;

  const bg = variant === 'primary' ? theme.accent
    : variant === 'secondary' ? theme.surface2
    : 'transparent';
  const color = variant === 'primary' ? theme.accentInk : theme.text;
  const border = variant === 'secondary' ? `1px solid ${theme.border}` : 'none';

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      style={{
        height: h, minWidth: h, padding: '0 16px',
        background: bg, color, border, borderRadius: 10,
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8,
        fontFamily: theme.font, fontWeight: 600, fontSize: fs,
        cursor: disabled || loading ? 'not-allowed' : 'pointer',
        opacity: disabled || loading ? 0.5 : 1,
        width: fullWidth ? '100%' : undefined,
        boxShadow: variant === 'primary' ? '0 1px 2px rgba(0,0,0,.08)' : 'none',
        transition: 'opacity .12s',
      }}
    >
      {icon && !loading && <Icon name={icon} size={fs + 4} stroke={2} />}
      {loading && <span style={{ fontSize: fs }}>…</span>}
      {children}
    </button>
  );
}
